import {
  GetChatSessionsApiResponse,
  GetChatSessionsLinks,
} from 'core_main/api/sessions/types';
import { conversationCallbackFieldsFromSessionAttributes } from 'core_main/sdk/conversation_callback_from_session_attributes';
import { normalizeSessionCustomAttributes } from 'core_main/sdk/chat_history_status_filter';
import { GetConversationsCallbackResponse } from './types';

export const parsePagesFromLinks = (
  links: GetChatSessionsLinks | undefined,
) => {
  if (!links) return undefined;

  const pages = Object.entries(links).reduce((acc, link) => {
    const key = link[0] as keyof GetChatSessionsLinks;
    const endpoint = link[1];

    let newAcc = {} as GetConversationsCallbackResponse['pages'];

    if (acc) newAcc = acc;

    const linkRegex = /(page=)([0-9]+)/g;

    let page: string | undefined | number = endpoint?.match(linkRegex)?.[0];

    if (typeof page === 'string') {
      const pageNumber = page.split('=')?.[1];
      page = Number.parseInt(pageNumber, 10);
    }

    if (!newAcc) return acc;

    if (key === 'prev') {
      newAcc.previous = page;
    } else if (key === 'self') {
      newAcc.current = page;
    } else {
      newAcc[key] = page;
    }

    return newAcc;
  }, {});

  return pages;
};

export const createGetConversationsCallbackResponse = (
  response: GetChatSessionsApiResponse,
): GetConversationsCallbackResponse => {
  const sessions = Array.isArray(response.data) ? response.data : [];
  const conversations = sessions
    .filter((session) => session.attributes.deleted !== true)
    .map((session) => {
      const custom = normalizeSessionCustomAttributes(
        session.attributes.custom,
      );
      return {
        ...conversationCallbackFieldsFromSessionAttributes(session.attributes),
        createdAt: session.attributes.createdAt,
        lastMessageAt: session.attributes.lastMessageAt,
        conversationId: session.id,
        ended: !!session.attributes.lockedAt,
        isInAssistantMode: session.attributes.isInAssistantMode,
        ...(custom ? { custom } : {}),
      };
    });

  return {
    conversations,
    pages: parsePagesFromLinks(response.links),
  };
};
